import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AuthenticationResponseModel } from '../model/authentication-response.model';
import { Globals } from '../../../globals';
import { UserService } from '../../../services/user.service';
import { DoctorsService } from '../../../services/doctors.service';
import { UiService } from '../../../services/ui.service';
import { SignalrService } from '../../../services/socket/signalr.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';

@Component({
  standalone: false,
  selector: 'app-office-auto-login',
  templateUrl: 'office-auto-login.component.html'
})
export class OfficeAutoLoginComponent implements OnInit {
  public outStr = 'Attempting auto login...';
  private returnUrl: string;
  returnParams: any = false;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private readonly globals: Globals,
    private readonly userService: UserService,
    private readonly doctorService: DoctorsService,
    private readonly uiService: UiService,
    private readonly signalrService: SignalrService,
    private readonly localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    if (localStorage.getItem('returnURL')) {
      this.returnUrl = localStorage.getItem('returnURL');
      localStorage.removeItem('returnURL');
    } else {
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    }

    if (localStorage.getItem('returnURLParameters')) {
      this.returnParams = JSON.parse(localStorage.getItem('returnURLParameters'));
      localStorage.removeItem('returnURLParameters');
    }

    const token = this.route.snapshot.paramMap.get('t');
    console.log('OfficeAutoLoginComponent ngOnInit entered token:', token);

    if (token) {
      this.authService.autoLoginTDOUser(token).subscribe((res: AuthenticationResponseModel) => {
        console.log('auto login response:', res);
        if (res.isSuccess) {
          localStorage.setItem('TDOauthToken', res.token);
          this.router.navigate(['/']);
          if (res.requirePasswordChange) {
            this.outStr = 'Password change required. Please use the regular login page.';
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 2000);
            return;
          }

          this.processLoginSuccess(res);
        } 
        else {
          this.outStr = 'Token Authentication Failed';
        }
      },
        (error) => {
          console.log('auto login error:', error);
          this.outStr = 'Token Authentication Failed';
        }
      );
    }
  }

  private processLoginSuccess(dataAuth: AuthenticationResponseModel) {
    // Set globals
    this.globals.LOCenumCountryId = dataAuth.locationCountryId;
    this.globals.showSuburbInAddress = this.globals.LOCenumCountryId !== '00000007-1000-0000-0000-000000000001'; // show if not usa

    // Store token result - this is critical for proper authentication state
    this.authService.storetokenResult(dataAuth);

    // Set logged in user
    this.setLoggedInUser(dataAuth);

    // Connect SignalR
    this.signalrService.connect();

    // Check if user is doctor and navigate
    this.doctorService.checkIfUserIsDoctor(dataAuth.userId).subscribe((res) => {
      if (res) {
        this.localStorageService.loggedInDoctorId = res.DoctorId;
      }
      this.uiService.clearMessages();
      if (this.returnParams) {
        this.router.navigate([this.returnUrl], { queryParams: this.returnParams });
      } else {
        this.router.navigate([this.returnUrl]);
      }
    });
  }

  private setLoggedInUser(dataAuth: AuthenticationResponseModel) {
    this.userService.loggedInUser = new TdoUserConfigurationModel();
    this.userService.loggedInUser.userid = dataAuth.userId;
    this.userService.loggedInUser.UserID = dataAuth.userId;
    this.userService.loggedInUser.WorkStationID = dataAuth.workStationId;
    this.globals.WorkStationID = dataAuth.workStationId;
    this.userService.loggedInUser.TDOCID = Number(dataAuth.tdoCId);
    this.userService.loggedInUser.UserNickName = dataAuth.userNickName;
  }
}